<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-14 09:49:41
-->
<template>
  <div>
    <div class="maintitle">部门考核</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="20">
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini' @keyup.enter.native="searchList"></el-input>
      </el-col>
      <el-date-picker v-model="month" type="month" placeholder="选择考核月份" size='mini'>
      </el-date-picker>
      <el-button @click="searchList" size='mini' class="margin-left">筛选</el-button>
    </el-row>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="department" label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份"></el-table-column>
      <el-table-column label="自评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.selfexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最终考核">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.excellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope.row.id)" size='mini'>查看</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <span v-else>{{ scope.row[item.prop] }}</span>
            <!-- <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-else v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table">
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!='final'">{{getBeizhu(item.detail,it.uuid)}}</span>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            {{formatExcellent(item.excellent)}}
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <span v-html="item.beizhu"></span>
          </td>
        </tr>
      </table>
      <div>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      total: 0,
      page: sessionStorage.getItem('final_assess_page') ? parseInt(sessionStorage.getItem('final_assess_page')) : 1,
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      hasscore:1,
      month:'',
      excellentlist:[],
      trList: [],
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid')
    };
  },
  computed: {
    alist() {
      if(this.hasscore==0) return this.info;
      let temp = {
        id: 0,
        title: '合计',
        selfscore: 0,
        finalscore:0
      }
      for (let item in this.info) {
        temp.selfscore += isNaN(parseFloat(this.info[item].selfscore)) ? 0 : parseFloat(this.info[item].selfscore);
        temp.finalscore += isNaN(parseFloat(this.info[item].finalscore)) ? 0 : parseFloat(this.info[item].finalscore);
      }
      temp.selfscore = parseInt(temp.selfscore * 100) / 100;
      temp.finalscore = parseInt(temp.finalscore * 100) / 100;
      // return this.info;
      return this.info.concat(temp);
    },
  },
  methods: {
    searchList(){
      this.page = 1;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/viewass/getDepList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword,
          month:this.month
        },
      }).then((res) => {
        this.list = res.data.list.data;
        this.total = res.data.list.total;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('leader_assess_page', p);
    },
    formatExcellent(e) {
      if(!e) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    getBeizhu(item,uuid) {
      for(let i in item){
        if(i == uuid){
          return item[i].beizhu
        }
      }
    },
    ass(id) {
      this.$axios({
        url: this.HOST + "/kaohe/viewass/getDepAssByAid",
        method: "post",
        data: {
          id: id
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for(let item in this.assessinfo.detail){
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.hasscore = res.data.hasscore;
          this.assDiv = true;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.shenheList = res.data.shenheList
          console.log(this.shenheList)
        }
      });
    },
  },
  created: function () {
    this.getlist();
  },
};
</script>
<style scoped>
.itemgroup {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px 20px 0 0;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
}
.itemgroup * {
  box-sizing: border-box;
}
.item-title {
  line-height: 28px;
}
</style>